<template>
  <v-layout class="px-5">
    <v-flex xs1 md1 class="pt-3">
      <slot></slot>
    </v-flex>
    <v-flex xs11 md4>
      <v-menu
        ref="menuDate"
        :close-on-content-click="false"
        v-model="menuDate"
        :nudge-right="40"
        :return-value.sync="period.date"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        :disabled="disabled"
      >
        <v-text-field
          slot="activator"
          :value="fdate(period.date)"
          label="วันที่"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="period.date" @input="$refs.menuDate.save(period.date)" no-title locale="th-Th" :disabled="disabled"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 md3>
      <v-text-field
        label="เวลาเริ่มต้น"
        placeholder="__:__"
        :value="period.startTime"
        @input="period.startTime = $event"
        mask="##:##"
        :rules=[rules.required]
      ></v-text-field>
    </v-flex>
    <!-- @change="$emit('update:period.startTime', $event);" -->
    <v-flex xs12 md3>
      <v-text-field
        label="เวลาสิ้นสุด"
        placeholder="__:__"
        :value="period.endTime"
        @input="period.endTime = $event"
        mask="##:##"
        :rules=[rules.required]
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  props: ['period'],
  data () {
    return {
      menuDate: false,
      ddate: null,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
    }
  },
  computed: {
    disabled () {
      return false
    }
  },
  mounted () {
    // console.log('period', this.period)
  },
  methods: {
    fdate (val) {
      this.$emit('update:date', val)
      return val ? this.$options.filters.formatFullDate(val) : null
    }
  },
  watch: {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/activity/shared/formPeriod.vue